import { cn } from '@/utils/cn'

interface TextCellProps {
  value?: string | null
  lineClamp?: 1 | 2
  fallback?: string
  className?: string
}

/**
 * A generic text cell component for AG Grid tables.
 * Displays text with optional line clamping and fallback value.
 */
export function TextCell({
  value,
  lineClamp = 1,
  fallback = '-',
  className,
}: TextCellProps) {
  const lineClampClass = lineClamp === 2 ? 'line-clamp-2' : 'truncate'

  return (
    <span className={cn('text-sm', lineClampClass, className)}>
      {value || fallback}
    </span>
  )
}
